import React from 'react';
import './CustomizedCake.css';
import { useNavigate } from 'react-router-dom';

function CustomizedCake() {
  const navigate = useNavigate();

  const handleEnquire = () => {
    navigate('/customize');
  };

  return (
    <div className="customized-cake-container">
      <div className="layout-wrapper">
        <div className="content-section">
          <div className="content-inner">
            <p className="cake-label">WORKSHOPS &amp; EVENTS</p>
            <h1 className="main-heading">Chai &amp; Connect</h1>
            <p className="tagline">Learn. Sip. Connect.</p>
            <p className="customize-text">
              Book a wellness workshop, order a gift box, or get in touch for events and bulk orders. Learn the art of karak chai, discover the benefits of traditional spices, and leave with your own chai kit. Perfect for teams, hen parties, and the curious soul.
            </p>
            <button className="get-cake-btn" onClick={handleEnquire}>
              Book Workshop or Enquire
            </button>
          </div>
        </div>
        <div className="image-section">
          <img
            src="/connect.jpeg"
            alt="Chai & Connect - Workshop"
            className="cake-image"
          />
        </div>
      </div>
    </div>
  );
}

export default CustomizedCake;
